<template>
  <div class="home-box">
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2 orange--text">Points</h3>
        <v-spacer></v-spacer>
        <v-btn v-if="activityStatus !== 'APPROVED' && activityStatus !== 'REJECTED' &&
          role === 'CLUBS_PERFORMANCE_EVALUATION'
          " color="blue" x-small dark title="Reload" @click="reloadPoints()" :disabled="loading">
          Refresh
        </v-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Description
              </th>
              <th class="text-right">
                Plus Points
              </th>
              <th class="text-right">
                Negative Points
              </th>
              <th class="text-right">
                Total Points
              </th>
              <th class="text-center">
                Status
              </th>
              <th class="text-left" colspan="2" v-if="role === 'CLUBS_PERFORMANCE_EVALUATION' && activityStatus !== 'REJECTED' &&
                activityStatus !== 'APPROVED'
                ">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="point in points" :key="point.id">
              <td v-if="point.items">
                {{ point.items.title }}
                <small v-if="point.comment">({{ point.comment }})</small>
              </td>
              <td class="text-right">{{ point.cr_points }}</td>
              <td class="text-right">{{ point.dr_points }}</td>
              <td class="text-right">{{ point.total_points }}</td>
              <td class="text-center">
                <v-chip x-small class="ma-2" dark :color="getStatusColor(point.status)">
                  {{ point.status }}
                </v-chip>
              </td>
              <td v-if="canManage(point.status) &&
                point.status !== 'APPROVED' && activityStatus !== 'REJECTED' &&
                role === 'CLUBS_PERFORMANCE_EVALUATION'
                ">
                <v-btn color="green" fab x-small dark title="Approve" @click="approve(point.id)">
                  <v-icon x-small> mdi-check </v-icon>
                </v-btn>
              </td>
              <td v-if="canManage(point.status) &&
                point.status !== 'REJECTED' && activityStatus !== 'REJECTED' &&
                role === 'CLUBS_PERFORMANCE_EVALUATION'
                ">
                <v-btn color="red" fab x-small dark title="Reject" @click="reject(point.id)">
                  <v-icon x-small> mdi-cancel </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <ConfirmModalWithComment :title="'Reject Points'" :color="'red'" :confirmCommentOpen="confirmCommentOpen"
        @cancelCommentConfirm="cancelCommentConfirm()" @confirmComment="confirmComment($event)"></ConfirmModalWithComment>
    </v-card>
   
  </div>
</template>

<script>
import { ActivityService } from "../../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";
import ConfirmModalWithComment from "@/components/shared/ConfirmModalWithComment";

export default {
  name: "ActivityEstimationPoints",

  components: { 
    ConfirmModalWithComment
  },

  data: () => ({
    loading: false,
    role: localStorage.getItem("role") || null,
    confirmCommentOpen: false,
    updateId: null,
    points: [],
    form: {
      id: null,
      reject_comments: "",
      status: "",
    },
    key: null,
    uuid: null,
    activityStatus: null,
  }),

  mounted() {
    this.key = this.$route.params.key;
    this.uuid = this.$route.params.aId;
    this.calculatePoints();
    this.reloadPoints();
    this.getPoints();
  },

  methods: {
    submit() {
      this.loading = true;
    },
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "APPROVED":
          bgColor = "green";
          break;

        case status === "REJECTED":
          bgColor = "red";
          break;

        case status === "PENDING":
          bgColor = "grey darken-1";
          break;
      }
      return bgColor;
    },
    calculatePoints() {
      this.loading = true;
      ActivityService.calculateActivityPoints(this.uuid, this.key)
        .then((response) => {
          this.loading = false;
          if (response.data.status_code == 200) {
            this.getPoints();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getPoints() {
      ActivityService.getActivityPoints(this.uuid, this.key)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.points = response.data.points;
            this.activityStatus = response.data.status;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.points = [];
          this.activityStatus = null;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    update() {
      this.form.uuid = this.uuid;
      this.form.key = this.key;
      ActivityService.updatePointStatus(this.form)
        .then((response) => {
          this.loading = false;
          if (response.data.status_code == 200) {
            this.getPoints();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.getPoints();
        });
    },

    reloadPoints() {
      ActivityService.calculateActivityPoints(this.uuid, this.key)
        .then((response) => {
          this.loading = false;
          if (response.data.message == "success") {
            this.getPoints();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    approve(id) {
      this.updateId = id;
      this.form.reject_comments = "";
      this.form.id = this.updateId;
      this.form.status = "APPROVED";
      this.update();
    },
    reject(id) {
      this.updateId = id;
      this.confirmCommentOpen = true;
    },
    confirmComment(value) {
      this.form.id = this.updateId;
      this.form.reject_comments = value;
      this.form.status = "REJECTED";
      this.update();
      this.confirmCommentOpen = false;
    },
    cancelCommentConfirm() {
      this.confirmCommentOpen = false;
    },

    canManage() {
      if (this.activityStatus !== "APPROVED") {
        return true;
      }
      return false;
    },
  },
};
</script>
